import produce from 'immer';
export var getInitialState = function () { return ({
    loading: false,
    error: false,
    app: {},
}); };
function selectedAppStateReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_SELECTEDAPP_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'LOAD_SELECTEDAPP_SUCCESS':
                state.loading = false;
                state.error = false;
                state.app = action.app || {};
                break;
            case 'LOAD_SELECTEDAPP_FAILURE':
                state.loading = false;
                state.error = true;
                state.app = {};
                break;
            case 'UPDATE_SELECTEDAPP_IMAGE_SUCCESS':
                state.app.icon = action.imageUrl;
                break;
            case 'UPDATE_SELECTEDAPP_NAME_SUCCESS':
                state.app.name = action.name;
                break;
            case 'CLEAR_SELECTEDAPP':
                state.app = {};
                break;
            default:
                break;
        }
    });
}
export default selectedAppStateReducer;
